.bettingSplits .toggleItem {
  position: relative;
  width: 100%;
}
.bettingSplits .toggleItem,
.bettingSplits .toggleItem span {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--cxy-spacing-xxsm);
}
.bettingSplits .indicatorCell {
  order: -1;
}
@media (--cxy-desktop) {
  .bettingSplits .indicatorCell {
    order: 1;
  }
}
.bettingSplits .indicatorCell > div {
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-end;
  gap: var(--cxy-spacing-xxxsm);
}
.bettingSplits .indicatorCell .indicator {
  margin-top: calc(var(--cxy-spacing-xxxsm) * -1);
}
.bettingSplits th:has(.mainHeading) {
  padding-inline: 0;
}
.bettingSplits .oddsButton button {
  width: 100%;
}
.bettingSplits .oddsButton p {
  display: none;
}
@media (max-width: 375px) {
  .bettingSplits {
    max-width: 100vw;
    overflow-x: hidden;
  }
  .bettingSplits .toggleItem,
  .bettingSplits .toggleItem span {
    gap: var(--cxy-spacing-xxxsm);
  }
  .bettingSplits .oddsButton {
    overflow: hidden;
  }
  .bettingSplits .oddsButton button {
    font-size: 0.875rem;
    padding: 0.25rem;
    max-width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
[data-fpsm-theme='plus'] .bettingSplits button,
[data-fpsm-theme='whoscored'] .bettingSplits button {
  @container (min-width: 800px) {
    width: 110px !important;
  }
}
@container (max-width: 400px) {
  .bettingSplits button {
    max-width: 100px !important;
    min-width: 80px;
    overflow: hidden;
  }

  [data-fpsm-theme='gazzetta'] {
    min-width: unset;
  }
}
[data-fpsm-theme='gazzetta'] .bettingSplits {
  button {
    min-width: 18px;
  }
}
.bettingSplits .additionalTitle td {
  position: relative;
}
.bettingSplits .additionalTitle td:not(:first-child):not(:last-child):after {
  position: absolute;
  content: 'Best Odds';
  inset-inline: 0;
  inset-block-start: 105%;
  display: flex;
  height: 68px;
  justify-content: center;
  align-items: center;
}
@media (--cxy-desktop) {
  .bettingSplits .additionalTitle td:not(:first-child):not(:last-child):after {
    display: none;
  }
}

.soccerRow {
  grid-template-columns: 1fr 1fr 1fr !important;
}
@media (max-width: 375px) {
  .soccerRow {
    gap: var(--cxy-spacing-xxxsm);
    max-width: 100%;
  }
}
